"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Cesium = window.Cesium;
/**
 * an implmentation speicifc coordinate. Contains untis to convert from cesium to standard coords
 * as well as placeholders for holding the cesium cartesian coords so they dont need to be recalced
 */
class CesiumCoordinate {
    constructor(cesiumCoord, screenCoord) {
        this._screenPos = null;
        if (cesiumCoord && cesiumCoord.x)
            CesiumCoordinate.catersianToCoord(cesiumCoord, screenCoord, this);
        this._screenPos = screenCoord;
    }
    get screenPosition() {
        if (this._screenPos == null)
            throw Error("TODO Cannot derive without the scene object so cannot htin of nice interface");
        //  this._screenPos = Cesium.SceneTransforms.wgs84ToDrawingBufferCoordinates(this.scene, this.cartesian)
        return this._screenPos;
    }
    get cartesian() {
        if (!this._cartesian)
            this._cartesian = Cesium.Cartesian3.fromCartographic(this);
        return this._cartesian;
    }
    static catersianToCoord(cartesian, screenCoord, ref) {
        ref = ref || new CesiumCoordinate(null, screenCoord);
        if (screenCoord)
            ref._screenPos = screenCoord;
        var cartographic = Cesium.Cartographic.fromCartesian(cartesian);
        ref.latitude = cartographic.latitude;
        ref.longitude = cartographic.longitude;
        ref.height = cartographic.height;
        ref._cartesian = cartesian;
        return ref;
    }
    setScreen(scene) {
        this._screenPos = scene.cartesianToCanvasCoordinates(this.cartesian);
    }
}
exports.CesiumCoordinate = CesiumCoordinate;
